import React from "react";

const ImageAspectRatioCacheContext = React.createContext({
  cache: {},
  cacheImageAspectRatio: () => {
    throw new Error(
      "override ImageAspectRatioCacheContext#cacheImageAspectRatio",
    );
  },
});

export default ImageAspectRatioCacheContext;
